import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ControlsModule } from 'src/app/controls/controls.module';
import { Exam } from 'src/app/models/exam.model';
import { RelativeDatePipe } from "../../../pipes/relative-date.pipe";

@Component({
  selector: 'app-exam-list',
  templateUrl: './exam-list.component.html',
  styleUrls: ['./exam-list.component.scss'],
  imports: [
    CommonModule,
    ControlsModule,
    TranslateModule,
    FormsModule,
    RelativeDatePipe
]
})
export class ExamListComponent {
  
  @Input() exams: Exam[] = [];
  dates: { date: Date, exams: Exam[] }[] = [];

  @Output() examClicked: EventEmitter<any> = new EventEmitter<Exam>();

  ngOnInit() {
    this.groupExamsByDate();
  }

  groupExamsByDate() {
    // Group exams by date
    const groupedExams: any = this.exams.reduce((acc, exam) => {
      const examDate = exam.date.toDateString(); // Use only the date part
      if (!acc[examDate]) {
        acc[examDate] = [];
      }
      acc[examDate].push(exam);
      return acc;
    }, {} as any);

    // Convert the grouped object to an array and sort by date descending
    this.dates = Object.keys(groupedExams).map(date => ({
      date: new Date(date),
      exams: groupedExams[date].sort((a: any, b: any) => new Date(b.date).getTime() - new Date(a.date).getTime())
    })).sort((a, b) => b.date.getTime() - a.date.getTime()); // Sort by descending date
  }

  handleExamClick(exam: Exam) {
    this.examClicked.emit(exam);
  }
}